export enum E_ProfileForm {
  NICKNAME = 'nickname',
  LANGUAGE = 'language',
  COUNTRY = 'country',
  HIDE_ACTIVITY = 'hideActivity'
}
